import styled from '@emotion/styled';

type Props = {
  duration: number;
  isActive: boolean;
  index: number;
  chars: string;
};

export const Character = styled.span<Props>`
  @keyframes variflow {
    0% {
      font-variation-settings: 'wght' 0;
    }
    50% {
      font-variation-settings: 'wght' 100;
    }
    100% {
      font-variation-settings: 'wght' 0;
    }
  }

  font-weight: 400;
  font-variation-settings: 'wght' 0;

  ${({ duration }) => `animation-duration: ${duration}ms;`}
  ${({ isActive }) => `animation-name: ${isActive ? 'variflow' : ''};`}

  animation-iteration-count: 1;
  animation-timing-function: ease-in-out;
  ${({ index, chars }) => `animation-delay: ${index / chars.length}s;`}
`;
